module.exports = __webpack_public_path__ + "static/media/sarvvid-logo.85f8cff7.svg";